import { render, staticRenderFns } from "./create_theme_copy.vue?vue&type=template&id=0f725882&scoped=true"
import script from "./create_theme_copy.vue?vue&type=script&lang=js"
export * from "./create_theme_copy.vue?vue&type=script&lang=js"
import style0 from "./create_theme_copy.vue?vue&type=style&index=0&id=0f725882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f725882",
  null
  
)

export default component.exports